import { useLang } from "../../i18n";
import { Reveal, SectionHead } from "./Section";

const Stats = () => {
  const { t } = useLang();
  return (
    <section className="px-6 lg:px-12 py-20 lg:py-28" data-testid="stats-section">
      <SectionHead index="06" overline={t.stats.overline} title={t.stats.title} align="center" />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#232733] border border-[#232733] mt-14">
        {t.stats.items.map((s, i) => (
          <Reveal key={i} delay={i * 0.08} className="bg-[#0A0B0E]">
            <div className="px-6 py-12 text-center group hover:bg-[#111318] transition-colors" data-testid={`stat-${i}`}>
              <div className="font-display text-4xl lg:text-6xl font-extrabold tracking-tighter text-white group-hover:text-[#0055FF] transition-colors">
                {s.value}
              </div>
              <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#647087] mt-4">{s.label}</div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default Stats;
